import dynamic from "next/dynamic";
import HubspotAndLogosFormConfig from "./hubspot-and-logos-form-config";
import HubspotAndLogosFormAdvancedConfig from "./hubspot-and-logos-form-advanced-config";
const HubspotAndLogosFormComponent = dynamic(()=>import("./hubspot-and-logos-form-component"));
export default {
    HubspotAndLogosFormComponent,
    HubspotAndLogosFormConfig,
    HubspotAndLogosFormAdvancedConfig
};
